var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap items-center justify-center transform",class:{
    'rotate-90':_vm.vertical
  }},_vm._l((_vm.numberOfDots),function(dot,index){return _c('div',{key:index,staticClass:" -mt-8 cursor-pointer rounded-full bg-white transition-all duration-500 ease-in-out",class:{
      'h-4 w-4':_vm.activeDots[index],
      'h-2 w-2':!_vm.activeDots[index],
      'ml-8':index!==0
    },on:{"click":function($event){return _vm.updateActiveDot(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }